import script from "./SpvInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./SpvInfo.vue?vue&type=script&setup=true&lang=js"

import "./SpvInfo.vue?vue&type=style&index=0&id=001d222c&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-001d222c"]])

export default __exports__